import { Link, Outlet } from "react-router-dom";
import { LabProvider } from "../../context/labContext";

const Labs = () => {
    return (
        <div className="h-100 p-5">
            <div className="d-flex justify-content-between align-items-center">
                <h1>Labs</h1>
                <Link to="new" className="btn btn-primary">
                    <i className="bi bi-plus"></i>
                    Add
                </Link>
            </div>

            <LabProvider>
                <Outlet />
            </LabProvider>
        </div>
    );
}

export default Labs;